<template>
  <div class="Exporthk3">
    <v-row>
      <v-col class="text-right">
        <!-- <v-btn
          type="button"
          @click="
            exportexcelhk3(
              tokenexport,
              exportthn,
              exportbln,
              exportps,
              paparnegeriexport
            )
          "
          color="blue white white--text"
        >
          <span class="material-icons">file_download</span>
          {{ $t("muatturun") }} {{ $t("hk3") }}
        </v-btn> -->
            <download-excel
              :data = "papardatahk3"
              type="csv"
              name="hk3.xls"
              >
              <v-btn type="button" color="blue white white--text">
                <span class="material-icons">file_download</span>
                {{ $t("muatturun") }} {{ $t("hk3") }}
              </v-btn>
            </download-excel>
      </v-col>
    </v-row>
    &nbsp;
    <v-row>
      <v-col cols="12" sm="12">
        <v-data-table
          :headers="headers"
          :items="papardatahk3"
          :items-per-page="10"
          class="elevation-1"
          height="500"
          fixed-header
        >
        </v-data-table>
      </v-col>
    </v-row>
  </div>
</template>
<script>
// import i18n from "@/i18n";
// import hidServices from "@/services/lookupField";
// const lookup = new hidServices();
import axios from "../../plugins/axios";
import Vue from 'vue';
import JsonExcel from "vue-json-excel";
Vue.component("downloadExcel", JsonExcel);
export default {
  Name: "Exporthk3",
  setup() {},
  props: [
    "papardatahk3",
    "exportthn",
    "exportbln",
    "exportps",
    "paparnegeriexport",
  ],
  mounted() {},
  data: () => ({
    tokenexport: window.localStorage.getItem("tokenexport"),
    databatch: "",
    headers: [
      { text: "Bil", value: "Bil"},
      { text: "HID", value: "HID"},
      { text: "BNO", value: "BNO"},
      { text: "Pusingan", value: "Pusingan"},
      { text: "S", value: "S"},
      { text: "NG", value: "NG"},
      { text: "DP", value: "DP"},
      { text: "DB", value: "DB"},
      { text: "BP", value: "BP"},
      { text: "ST", value: "ST"},
      { text: "NOTK", value: "NOTK"},
      { text: "NOIR", value: "NOIR"},
      { text: "NOAIR", value: "NOAIR"},
      // { text: "KAW", value: "KAW"},
      // { text: "Bulan", value: "Bulan"},
      // { text: "Tahun", value: "Tahun"},
      // { text: "BPK", value: "BPK"},
      // { text: "IDBPK", value: "IDBPK"},
      { text: "HK3C1", value: "HK3C1"},
      { text: "HK3C2", value: "HK3C2"},
      { text: "HK3C3", value: "HK3C3"},
      { text: "HK3C4", value: "HK3C4"},
      { text: "HK3C5", value: "HK3C5"},
      //{ text: "PENHK3", value: "PENHK3"},
      { text: "P", value: "P"},
      { text: "HK321A_i", value: "HK321A_i"},
      { text: "HK321A_ii", value: "HK321A_ii"},
      { text: "HK321A_iii", value: "HK321A_iii"},
      { text: "HK3INCS21A_i", value: "HK3INCS21A_i"},
      { text: "HK3INCS21A_ii", value: "HK3INCS21A_ii"},
      { text: "HK3INCS21A_iii", value: "HK3INCS21A_iii"},
      { text: "HK3INCS21a", value: "HK3INCS21a"},
      { text: "HK3A1", value: "HK3A1"},
      { text: "HK3A2", value: "HK3A2"},
      { text: "HK3A3", value: "HK3A3"},
      { text: "HK3A4", value: "HK3A4"},
      { text: "HK3B", value: "HK3B"},
      { text: "HK3B1", value: "HK3B1"},
      { text: "HK3B2", value: "HK3B2"},
      { text: "HK3M", value: "HK3M"},
      { text: "HK3S38", value: "HK3S38"},
      { text: "HK3S39", value: "HK3S39"},
      { text: "KL", value: "KL"},
      { text: "PK", value: "PK"},
      { text: "PN", value: "PN"},
      // { text: "dateMula", value: "dateMula"},
      // { text: "dateTamat", value: "dateTamat"},
    ],
  }),
  methods: {
    async exportexcelhk3(
      tokenexport,
      exportthn,
      exportbln,
      exportps,
      paparnegeriexport
    ) {
      try {
        await axios
          .post(`${process.env.VUE_APP_API_URL}/sec/checksession`, {
            tokenexportsess: window.localStorage.getItem("tokenexport"),
          })
          .then((result) => {
            console.log(result.data.status);
            if (result.data.status) {
              window.open(
                `${process.env.VUE_APP_API_URL}/HK/exporthk3serverside/${tokenexport}/${exportthn}/${exportbln}/${exportps}/${paparnegeriexport}/`,
                "_blank"
              );
            }
          });
      } catch (error) {
        console.log(error);
      }
    },
  },
};
</script>